import { useTranslator } from "@eo-locale/react";

import { Box } from "@chakra-ui/react";

import { sanitizeHref } from "@/lib";
import { useAppSelector } from "@/redux/store/hooks";

import SearchBar from "../search-bar";
import MobileNavLinks from "./nav-links";

const AuthLinks = () => {
  const { translate } = useTranslator();
  const { profile } = useAppSelector((state) => state.user.registeredUser);
  const { id, roleName } = profile;
  const { homePageRevision } = useAppSelector(
    (state) => state.homePageRevision
  );
  const backgroundColor =
    homePageRevision?.sections?.sections[0].theme.mainNavbarBackgroundColor;

  const { data } = homePageRevision?.sections?.sections[0] || {};
  const { signInText, signInUrl, signUpText, signUpUrl } =
    (Array.isArray(data) && data.length > 0 && data[0]) || {};

  const { settings } = useAppSelector((state) => state.settings);
  if (id && roleName) {
    return (
      <Box
        className="auth-links-container mobile-links-container"
        backgroundColor={backgroundColor}
      >
        <MobileNavLinks sectionId="0" loggedInUser="admin" />
        <SearchBar />
      </Box>
    );
  } else {
    return (
      <ul className="auth-links__list">
        <li className="auth-links__list__list-item">
          <a
            href={sanitizeHref(signInUrl)}
            className="auth-links__list__list-item__link"
          >
            {signInText || translate("participantHeader.signIn")}
          </a>
        </li>
        {!settings.disableSignup && (
          <li className="auth-links__list__list-item">
            <a
              href={sanitizeHref(signUpUrl)}
              className="auth-links__list__list-item__link"
            >
              {signUpText || translate("participantHeader.signUp")}
            </a>
          </li>
        )}
      </ul>
    );
  }
};

export default AuthLinks;
